<app-progress-bar [loading]="loading" />

<app-header-wrapper />

<app-flex
  align="flex-start"
  gap="0"
>
  @if (user && !user.is_company_gc && user.company_type === 'contractor') {
    <app-sidebar [user]="user" />
  }
  <div
    class="content-wrapper"
    [class.content-wrapper-sc-mobile]="user && !user.is_company_gc && user.company_type === 'contractor'"
  >
    <app-admin-alerts-container class="alerts-container" />
    <router-outlet />
  </div>
</app-flex>

@if (!isProd) {
  <div
    class="hubspot-mock-widget"
    title="Hubspot mock widget"
  ></div>
}
